(ns journal-app-client.components.particles)

;; TODO: This should probably be implemented using canvas for performance reasons.
;; But this works when keeping the particle count low as we are using css animations which are hardware accelerated
(defn main [& [props]]
  (let [colors ["var(--primary-brand-color)" "var(--green)" "var(--red)" "var(--blue)" "var(--cyan)" "var(--yellow)"]
        random-color #(-> colors shuffle first)
        color (:color props)
        amount-of-particles (or (:amount-of-particles props)
                              (:number-of-particles props)
                              (:spawn-count props)
                              (:count props)
                              20)
        id (or "particles" (:id props))
        min-size (or (:min-size props) 1)
        max-size (or (:max-size props) 3)
        size-unit (or (:size-unit props) "vmin")
        animation-iteration-count (or (:animation-iteration-count props) "infinite")
        animation-timing-function (or (:animation-timing-function props) "ease-out")
        min-speed (or (:min-speed props) 3000)
        max-speed (or (:max-speed props) 5000)
        initial-vx (:initial-vx props)
        initial-vy (:initial-vy props)
        initial-speed (Math/sqrt (+ (* initial-vx initial-vx) (* initial-vy initial-vy)))
        min-delay (or (:min-delay props) 0)
        max-delay (or (:max-delay props) 0)
        delay (:delay props)
        bounding-box (:bounding-box props)
        start-x-min (or (:start-x-min props) (first bounding-box))
        start-x-max (or (:start-x-max props) (second bounding-box))
        start-y-min (or (:start-y-min props) (nth bounding-box 2))
        start-y-max (or (:start-y-max props) (nth bounding-box 3))
        start-y (or (:start-y props) 50)
        start-x (or (:start-x props) 50)
        start-x-unit (or (:start-x-unit props) "%")
        start-y-unit (or (:start-y-unit props) "%")
        end-x-max (or (:end-x-max props) 100)
        end-y-max (or (:end-y-max props) 100)
        end-x-max-off-set (/ end-x-max 2)
        end-y-max-off-set (/ end-y-max 2)
        end-x (:end-x props)
        end-y (:end-y props)
        end-x-unit (or (:end-x-unit props) "svw")
        end-y-unit (or (:end-y-unit props) "svh")
        rotate-canvas (:rotate-canvas props)]
    (into
      [:div
       {:id id
        :key (:key props)
        :style (merge
                 {:position "fixed"
                  :width "100%"
                  :height "100%"
                  :pointer-events "none"
                  :transform (when rotate-canvas (str "rotate(" rotate-canvas "deg)"))}
                 (:style props))}]
      (map
        (fn [x]
          (let [start-x (or start-x (+ start-x-min (rand-int (- start-x-max start-x-min))))
                start-y (or start-y (+ start-y-min (rand-int (- start-y-max start-y-min))))
                size (+ min-size (rand-int (- max-size min-size)))
                speed (+ initial-speed min-speed (rand-int (- max-speed min-speed)))
                end-x (* (/ speed max-speed)
                        (or end-x
                          (if (and initial-vx (not (= initial-vx 0)))
                            (if (> initial-vx 0)
                              (Math/abs (- end-x-max-off-set (rand-int end-x-max)))
                              (- (Math/abs (- end-x-max-off-set (rand-int end-x-max)))))
                            (- end-x-max-off-set (rand-int end-x-max)))))
                end-y (* (/ speed max-speed)
                        (or end-y
                          (if (and initial-vy (not (= initial-vy 0)))
                            (if (> initial-vy 0)
                              (Math/abs (- end-y-max-off-set (rand-int end-y-max)))
                              (- (Math/abs (- end-y-max-off-set (rand-int end-y-max)))))
                            (- end-y-max-off-set (rand-int end-y-max)))))
                delay (or delay (let [delay (rand-int max-delay)]
                                  (if (>= delay min-delay)
                                    delay
                                    min-delay)))]
            [:div
             {:key   (str (or (:particle-key props) id) "-" x)
              :class "particles"
              :style {"--size"                      (str size size-unit)
                      "--speed"                     (str speed "ms")
                      "--delay"                     (str delay "ms")
                      "--animation-iteration-count" animation-iteration-count
                      "--animation-timing-function" animation-timing-function
                      "--start-y"                   (str start-y start-y-unit)
                      "--start-x"                   (str start-x start-x-unit)
                      "--end-y"                     (str end-y end-y-unit)
                      "--end-x"                     (str end-x end-x-unit)
                      :pointer-events "none"
                      :animation-direction          (or (:animation-direction props) (:animation-direction (:style props)))
                      :background                   (or color (random-color))
                      :border-radius                "50%"}}]))
        (range amount-of-particles)))))

;; Examples:
#_[particles/main
   {:id "first-explosion"
    :animation-iteration-count 1
    :min-speed 750
    :max-speed 1000
    :delay 0}]
#_[particles/main
   {:id "second-explosion"
    :animation-iteration-count 1
    :start-x 25
    :start-y 40
    :min-speed 750
    :max-speed 1000
    :delay 3000}]
#_[particles/main
   {:id "third-explosion"
    :animation-iteration-count 1
    :start-x 75
    :start-y 40
    :min-speed 750
    :max-speed 1000
    :delay 4000}]
